import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=4eb4b4b2"
import script from "./CustomerCard.vue?vue&type=script&lang=js"
export * from "./CustomerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports